module.exports = __webpack_public_path__ + "static/media/usericon.bc4a4a72.svg";